var App;

App = require('config/app');

module.exports = App.DocumentsRoute = Ember.Route.extend({
  activate: function() {
    return document.title = 'Poe';
  },
  model: function(params) {
    return (this.get('store')).find('document');
  },
  actions: {
    destroyRecord: function(record) {
      if (window.confirm('Are you sure you want to delete this document?')) {
        record.deleteRecord();
        if (record.currentState.stateName !== 'root.deleted.saved') {
          record.save();
        }
        return this.transitionTo('documents');
      }
    }
  }
});
